<template>
  <div>
    <v-row no-gutters justify-sm="center" justify-lg="space-around">
      <v-col
        v-if="this.clickOnButtonToDisplayTheMap === false"
        class="relative pb-4"
        v-bind:class="{ 'pl-4': $vuetify.breakpoint.mdAndUp }"
        :cols="12"
        :lg="responsiveColTheSearch.posts.lg"
        :md="responsiveColTheSearch.posts.md"
        :sm="responsiveColTheSearch.posts.sm"
      >
        <!-- Destination Resume -->
        <div
          v-if="searchStateDestinationDisplay && $vuetify.breakpoint.mdAndUp"
          class="absolute"
          style="top:0px; bottom:0px; left:0px;right:0px; z-index: 2"
        >
          <div
            class="sticky pl-4 pb-4 view-background-color"
            :style="destinationStyles"
          >
            <SearchDestinationPage
              :destination="destinationDisplayed"
              :searchParams="searchParams"
              @closeDestinationPage="closeDestinationPage"
              :destinationPageResponsiveColPost="
                destinationPageResponsiveColPost
              "
            ></SearchDestinationPage>
          </div>
        </div>
        <!-- Search components -->
        <div
          class="search-components sticky view-background-color py-4"
          :style="`top: ${$vuetify.breakpoint.lgAndUp ? '64px' : '56px'}`"
          v-bind:class="{ 'px-4': $vuetify.breakpoint.smAndDown }"
        >
          <div class="d-flex flex-wrap align-center">
            <SearchLocationAutocomplete
              :locationData="
                this.searchParams.getLocationDataForDestinationAutocomplete()
              "
              :placeType="this.searchParams.placeType"
              @updateDestinationAutocomplete="updateDestinationFromAutocomplete"
              @updateNavigatorPosition="updateNavigatorPosition"
              @searchXkmAroundMe="searchXkmAroundMe"
              ref="searchLocationAutocomplete"
            ></SearchLocationAutocomplete>
          </div>
          <SearchLocationActivation
            @redoSearch="
              updateSearchParams();
              newSearch();
            "
          ></SearchLocationActivation>
          <!-- DISPLAY NUMBER RESULT -->
          <div class="mt-2">
            <v-sheet
              v-if="searchLoading"
              color="grey lighten-2"
              height="28px"
              width="144px"
              class="rounded-pill"
            ></v-sheet>
            <SearchDisplayNumberResult
              v-else
              :resultCount="
                searchType === 'destinations'
                  ? searchDestinations.count
                  : searchPosts.count
              "
              :searchType="searchType"
            >
            </SearchDisplayNumberResult>
          </div>

          <div class="d-flex flex-wrap">
            <SearchDistanceSelector
              :radius="this.searchParams.radius"
              :placeType="this.searchParams.placeType"
              @updateSearchRadius="updateSearchRadius"
              class="mt-3 flex-grow-1"
            ></SearchDistanceSelector>
          </div>
          <SearchFilters
            v-if="$vuetify.breakpoint.mdAndUp"
            :search="searchParams"
            @updateSearchedMedia="updateSearchedMedia"
            @updateParameter="updateParameter"
          >
          </SearchFilters>
        </div>
        <!-- Posts Layout -->
        <div class="search-posts" v-if="searchType === 'posts'">
          <!-- LOADING POSTS STATE -->
          <v-row v-if="searchLoading" no-gutters>
            <v-col
              v-for="n in 20"
              :key="n"
              :cols="theSearchResponsiveColPost"
              class="pa-1"
            >
              <BasePostCardLoading></BasePostCardLoading>
            </v-col>
          </v-row>

          <!-- DISPLAY POSTS STATE -->
          <v-row
            v-else-if="!searchLoading && searchPosts.posts.length > 0"
            no-gutters
          >
            <v-col
              v-for="post in searchPosts.posts"
              :key="post.id"
              class="pa-1"
              :cols="theSearchResponsiveColPost"
            >
              <BaseExperienceCard
                :post="post"
                :postIsEditable="postsAreEditable"
              >
              </BaseExperienceCard>
            </v-col>

            <!-- <BasePostCard
              v-for="(post, index) in this.searchPosts.posts"
              :key="index"
              :post="post"
              @hoverLocation="highlightLocation"
              @leaveLocation="unHighlightLocation"
              class="mr-2 my-2"
              :postIsEditable="postsAreEditable"
            >
            </BasePostCard> -->

            <!-- Pagination -->
            <v-col cols="12">
              <v-pagination
                :value="searchParams.page"
                :length="searchPosts.numPages"
                :total-visible="5"
                @input="updatePageFromPagination"
                circle
                next-icon="keyboard_arrow_right"
                prev-icon="keyboard_arrow_left"
              ></v-pagination>
            </v-col>

            <v-col cols="12" class="text-center font-weight-light text-body-2">
              {{
                `${
                  searchPosts.posts.length > 1
                    ? (searchParams.page - 1) * 20 +
                      1 +
                      " - " +
                      ((searchParams.page - 1) * 20 +
                        searchPosts.posts.length) +
                      " " +
                      $t("app.plural_SHARE")
                    : (searchParams.page - 1) * 20 +
                      1 +
                      (searchParams.page > 1
                        ? " ième " + $t("app.singular_SHARE")
                        : " " + $t("app.singular_SHARE"))
                } ${
                  searchPosts.numPages > 1
                    ? searchParams.page == searchPosts.numPages
                      ? "sur " +
                        ((searchParams.page - 1) * 20 +
                          searchPosts.posts.length) +
                        " " +
                        $t("app.plural_SHARE")
                      : "sur plus de " +
                        (searchPosts.numPages * 20 - 20) +
                        " " +
                        $t("app.plural_SHARE")
                    : ""
                }`
              }}
            </v-col>
          </v-row>
          <!-- DISPLAY NO POSTS STATE -->
          <div
            v-else-if="!searchLoading && searchPosts.posts.length === 0"
            v-text="$t('search.noPosts')"
            class="full--height text-center text-h6 mt-4 primary--text"
          ></div>
        </div>
        <!-- Destinations Layout -->
        <div v-if="searchType === 'destinations'">
          <!-- LOADING DESTINATIONS STATE -->
          <v-row v-if="searchLoading" no-gutters>
            <v-col
              :cols="theSearchResponsiveColDestination"
              v-for="n in 30"
              :key="n"
              class="pa-1"
            >
              <SearchDestinationCardLoading></SearchDestinationCardLoading>
            </v-col>
          </v-row>
          <!-- DISPLAY DESTINATIONS STATE -->
          <div
            v-else-if="
              !searchLoading && searchDestinations.destinations.length > 0
            "
            class="relative"
          >
            <!-- v-bind:class="{ 'justify-md-center': $route.name === 'profile' }" -->

            <v-row no-gutters>
              <v-col
                :cols="theSearchResponsiveColDestination"
                v-for="destination in searchDestinations.destinations"
                :key="destination.id"
                class="pa-1"
              >
                <SearchDestinationCard :destination="destination">
                </SearchDestinationCard>
              </v-col>
            </v-row>

            <v-pagination
              :value="searchParams.page"
              :length="searchDestinations.numPages"
              :total-visible="5"
              @input="updatePageFromPagination"
              circle
              next-icon="keyboard_arrow_right"
              prev-icon="keyboard_arrow_left"
            ></v-pagination>
            <v-col cols="12" class="text-center font-weight-light text-body-2">
              {{
                `${
                  searchDestinations.destinations.length > 1
                    ? (searchParams.page - 1) * 30 +
                      1 +
                      " - " +
                      ((searchParams.page - 1) * 30 +
                        searchDestinations.destinations.length) +
                      " " +
                      $t("app.plural_GEM")
                    : (searchParams.page - 1) * 30 +
                      1 +
                      (searchParams.page > 1
                        ? " ième " + $t("app.singular_GEM")
                        : " " + $t("app.singular_GEM"))
                } sur ${searchDestinations.count +
                  " " +
                  (searchDestinations.count > 1
                    ? $t("app.plural_GEM")
                    : $t("app.singular_GEM"))}`
              }}
            </v-col>
            <v-btn
              v-if="this.displayToogleLayoutButtons"
              @click="
                clickOnButtonToDisplayTheMap = !clickOnButtonToDisplayTheMap
              "
              rounded
              color="primary"
              class="text-capitalize mb-5 sticky mx-auto d-block"
              style="bottom:36px"
            >
              <v-icon color="white">fas fa-map</v-icon>
              &nbsp;
              {{ $t("search.seeMap") }}
            </v-btn>
          </div>

          <!-- DISPLAY NO DESTINATION FOUND -->
          <div
            v-else-if="
              !searchLoading && searchDestinations.destinations.length === 0
            "
            class="text-center"
          >
            <span class="text-h6" v-text="$t('search.noPosts')"></span>
          </div>
        </div>
      </v-col>

      <!-- Search Map -->
      <v-col
        class="d-flex justify-start align-center flex-column pa-4"
        v-if="searchType === 'destinations'"
        :cols="12"
        :lg="responsiveColTheSearch.map.lg"
        :md="responsiveColTheSearch.map.md"
        :sm="responsiveColTheSearch.map.sm"
      >
        <div
          :style="theMapClasses"
          v-show="
            this.screenSizeAllowTheMapToBeDisplay ||
              this.clickOnButtonToDisplayTheMap === true
          "
          class="sticky full--width full-- height grey-border"
        >
          <div class="relative full--width full--height d-flex justify-center">
            <TheMap
              ref="theMap"
              :destinations="searchDestinations.destinations"
              :shortName="searchParams.shortName"
              :placeType="searchParams.placeType"
              :longitude="searchParams.longitude"
              :latitude="searchParams.latitude"
              :bbox="searchParams.bbox"
              :radius="this.searchParams.radius"
              :searchIfMapMove="searchIfMapMove"
              :screenSizeAllowTheMapToBeDisplay="
                screenSizeAllowTheMapToBeDisplay
              "
              :clickOnButtonToDisplayTheMap="clickOnButtonToDisplayTheMap"
              @stopLoadingMap="stopLoadingMap"
              @bboxHasBeenUpdated="bboxHasBeenUpdated"
              @mapMovementState="mapMovementState"
              @mapBoxStyleHasBeenCharged="isTheMapHasBeenCharged = true"
            ></TheMap>
            <MapCircleLoader
              v-if="this.loading.map"
              class="circleLoader"
              v-bind:class="{ opacityCircleLoader: this.loading.initMap }"
            ></MapCircleLoader>
            <!-- Close Map Button / Visible smAndDown -->
            <v-btn
              v-if="this.displayToogleLayoutButtons"
              @click="
                clickOnButtonToDisplayTheMap = !clickOnButtonToDisplayTheMap
              "
              absolute
              rounded
              bottom
              color="primary"
              class="text-capitalize mb-1"
            >
              <v-icon color="white">fas fa-list</v-icon>
              &nbsp;
              {{ $t("search.seeList") }}
            </v-btn>
            <!-- New Search or AutoSearchWhenMapMove Action -->
            <TheSearchNewSearchOnScrollingButton
              v-if="!this.loading.initMap"
              :isMapHadMoved="isMapHadMoved"
              :loading="searchLoading"
              @switchSearchIfMapMove="switchSearchIfMapMove"
              @searchInThisArea="searchInThisArea"
              class="absolute mt-2 scoped--TheSearchNewSearchOnScrollingButton"
            >
            </TheSearchNewSearchOnScrollingButton>
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- SearchDestinationPage For Mobile Display -->
    <v-bottom-sheet
      :value="searchStateDestinationDisplay && $vuetify.breakpoint.smAndDown"
      scrollable
      fullscreen
      :eager="true"
    >
      <SearchDestinationPage
        v-if="searchStateDestinationDisplay"
        :destination="destinationDisplayed"
        :searchParams="searchParams"
        :displayMobile="true"
        :destinationPageResponsiveColPost="destinationPageResponsiveColPost"
        @closeDestinationPage="closeDestinationPage"
      ></SearchDestinationPage>
    </v-bottom-sheet>
    <!-- SearchFilterMobile For Mobile Display -->
    <SearchFiltersMobile
      :search="searchParams"
      :resultToDisplay="
        searchType === 'destinations'
          ? `${searchDestinations.count} Destinations `
          : `${searchPosts.count} Partages`
      "
      @updateParameter="updateParameter"
      ref="searchFiltersMobile"
    ></SearchFiltersMobile>
    <!-- SearchFilterMobile button activation -->
    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      @click="openSearchFiltersMobile()"
      rounded
      fixed
      fab
      bottom
      right
      class="text-capitalize"
      v-bind:class="{
        'active-search-input': searchParams.isFiltersActivated(),
      }"
    >
      <div class="d-flex flex-wrap flex-column align-center">
        <v-icon
          :color="searchParams.isFiltersActivated() ? 'primary' : 'grey'"
          small
          >fas fa-filter</v-icon
        >
        <span
          :class="
            `text-caption font-weight-medium ${
              searchParams.isFiltersActivated()
                ? 'primary--text'
                : 'text--secondary'
            }`
          "
          >Filtres</span
        >
      </div>
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

/* Components */
import BasePostCardLoading from "../../core/components/BasePostCardLoading";
import BaseExperienceCard from "../../core/components/BaseExperienceCard";

import TheMap from "./Map/TheMap";

import SearchLocationAutocomplete from "./SearchLocationAutocomplete.vue";
import TheSearchNewSearchOnScrollingButton from "./TheSearchNewSearchOnScrollingButton.vue";

import MapCircleLoader from "./Map/MapCircleLoader";
import SearchDestinationCard from "./SearchDestinationCard";
import SearchDestinationCardLoading from "./SearchDestinationCardLoading";
import SearchDestinationPage from "./SearchDestinationPage";
import SearchDistanceSelector from "./SearchDistanceSelector";
import SearchDisplayNumberResult from "./SearchDisplayNumberResult";
import SearchFilters from "./SearchFilters.vue";
import SearchFiltersMobile from "./SearchFiltersMobile.vue";
import SearchLocationActivation from "./SearchLocationActivation";
/* Service */
import SearchService from "../services/SearchService";
import SearchStateService from "../services/SearchStateService";

export default {
  name: "TheSearch",
  props: {
    username: {
      type: String,
    },
    responsiveColTheSearch: {
      type: Object,
      required: true,
    },
    theSearchResponsiveColDestination: {
      type: String,
      default: () => "12",
    },
    theSearchResponsiveColPost: {
      type: String,
      default: () => "12",
    },
    destinationPageResponsiveColPost: {
      type: String,
      default: () => "12",
    },
    searchType: {
      type: String,
      required: true,
      default: () => "destinations",
    },
    postsAreEditable: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    BaseExperienceCard,
    SearchDestinationPage,
    SearchDestinationCard,
    SearchDestinationCardLoading,
    SearchDistanceSelector,
    SearchDisplayNumberResult,
    SearchFiltersMobile,
    SearchLocationActivation,
    TheMap,
    BasePostCardLoading,
    SearchLocationAutocomplete,
    SearchFilters,
    MapCircleLoader,
    TheSearchNewSearchOnScrollingButton,
  },
  data() {
    return {
      loading: {
        map: true,
        initMap: true,
      },
      isTheMapHasBeenCharged: false,
      isTheSearchReady: false,
      bbox: [],
      /* To display map through a button */
      clickOnButtonToDisplayTheMap: false,
      /* Used to change state for TheSearchNewSearchOnScrollingButton */
      isMapHadMoved: false,
      /* Used to trigger a API call if True */
      searchIfMapMove: false,
      /* Trigger when map is moving from FitBounds */
      isTheMapMovingBounds: false,
    };
  },
  computed: {
    // String Computed Property watched for launching a new Search.
    searchUrlParams() {
      // extract string after ? to create UrlSearchParams Object
      let searchQueryString = "";
      let indexOfQueryStart = this.$route.fullPath.indexOf("?");
      if (Number.isInteger(indexOfQueryStart) && indexOfQueryStart > -1) {
        searchQueryString = this.$route.fullPath.substr(indexOfQueryStart + 1);
      }
      let searchUrlParams = new URLSearchParams(searchQueryString);
      // Remove all TheSearch state URL Params
      searchUrlParams.delete("destinationDisplay");
      searchUrlParams.delete("destinationId");
      return searchUrlParams.toString();
    },
    // String Computed Property watched for TheSearch State properties.
    stateUrlParams() {
      return { ...this.$route.query.displayDestination };
    },
    // SearchParams stored in search vuex module
    ...mapState({
      searchParams: (state) => state.search.searchParams,
      searchLoading: (state) => state.search.searchLoading,
      searchDestinations: (state) => state.search.searchDestinations,
      searchStateDestinationDisplay: (state) =>
        state.search.destinationState.display,
      searchPosts: (state) => state.search.searchPosts,
      themesByCategoryLoading: (state) => state.core.themesByCategoryLoading,
      isFetchingThemesByCategory: (state) =>
        state.core.isFetchingThemesByCategory,
    }),
    ...mapGetters({
      destinationDisplayed: "search/destinationDisplayed",
      isThemesByCategoryHaveBeenFetched:
        "core/isThemesByCategoryHaveBeenFetched",
    }),
    screenSizeAllowTheMapToBeDisplay() {
      if (this.$vuetify.breakpoint.lgAndUp) return true;
      if (this.$vuetify.breakpoint.mdAndUp && /home/.test(this.$route.name))
        return true;
      return false;
    },
    displayToogleLayoutButtons() {
      if (this.$vuetify.breakpoint.lgAndUp) return false;
      if (this.$vuetify.breakpoint.mdAndUp && /home/.test(this.$route.name))
        return false;
      return true;
    },
    theMapClasses() {
      if (this.$vuetify.breakpoint.lgAndUp)
        return `top: 80px; height: calc(100vh - 64px - 32px)`;
      return `top: 72px; height: calc(100vh - 64px - 24px)`;
    },
    destinationStyles() {
      if (this.$vuetify.breakpoint.lgAndUp)
        return `top: 80px; height: calc(100vh - 64px - 32px + 16px)`;
      return `top: 72px; height: calc(100vh - 64px - 24px + 16px)`;
    },
  },
  watch: {
    searchUrlParams() {
      this.updateSearchParams();
      this.newSearch();
    },
    stateUrlParams() {
      this.updateState();
    },
    // Switch once from false to true when core stored ThemesByCategory has been fetched.
    isThemesByCategoryHaveBeenFetched(value) {
      if (value) {
        // Dont wait mapbox style to be charged to retrieve data
        if (this.searchType === "posts") {
          this.launchFirstSearchAfterTheSearchHasBeenCreated();
          //  Wait mapbox style to be charged to retrieve data
        } else if (this.isTheMapHasBeenCharged) {
          this.launchFirstSearchAfterTheSearchHasBeenCreated();
        }
      }
    },
    // Switch once from false to true when TheMap has been charged.
    isTheMapHasBeenCharged(value) {
      if (value && this.isThemesByCategoryHaveBeenFetched) {
        this.launchFirstSearchAfterTheSearchHasBeenCreated();
      }
    },
    isTheSearchReady(value) {
      if (value) {
        if (
          this.searchType === "destinations" &&
          this.isThemesByCategoryHaveBeenFetched &&
          this.isTheMapHasBeenCharged
        ) {
          this.launchFirstSearchAfterTheSearchHasBeenCreated();
        } else if (
          this.searchType === "posts" &&
          this.isThemesByCategoryHaveBeenFetched
        ) {
          this.launchFirstSearchAfterTheSearchHasBeenCreated();
        }
      }
    },
  },
  methods: {
    // For searchType === destination : Is trigger after map style and themesByCategories have been repectively charged and fetched.
    // For searchType === posts : Is trigger after themesByCategories has been fetched.
    launchFirstSearchAfterTheSearchHasBeenCreated() {
      this.updateSearchParams();
      this.updateState();
      this.newSearch();
    },
    /*Trigger by SearchLocationAutocomplete when user search around him*/
    updateNavigatorPosition(position) {
      const { latitude, longitude } = position.coords;
      sessionStorage.setItem("clientLongitude", longitude);
      sessionStorage.setItem("clientLatitude", latitude);
      const bbox = SearchService.getBboxFromCoordsAndRadius(
        longitude,
        latitude,
        20
      );
      this.bbox = bbox;
      this.updateHomeUrl(
        SearchService.getSearchQueryParamsfromNavigatorLocation(
          { ...this.$route.query },
          this.bbox,
          longitude,
          latitude,
          20
        )
      );
    },
    searchXkmAroundMe({ position, kilometers }) {
      const { latitude, longitude } = position.coords;
      const bbox = SearchService.getBboxFromCoordsAndRadius(
        longitude,
        latitude,
        kilometers
      );
      this.bbox = bbox;
      this.updateHomeUrl(
        SearchService.getSearchQueryParamsfromNavigatorLocation(
          { ...this.$route.query },
          this.bbox,
          longitude,
          latitude,
          kilometers
        )
      );
    },
    /*Trigger by SearchLocationAutocomplete*/
    updateDestinationFromAutocomplete(select) {
      let bbox = [];
      switch (select.placeType) {
        case "address":
        case "poi":
        case "neighborhood":
        case "locality":
          bbox = SearchService.getBboxFromCoordsAndRadius(
            select.coordinates[0],
            select.coordinates[1],
            5
          );
          select.bbox = [bbox.xMin, bbox.yMin, bbox.xMax, bbox.yMax];
          this.updateHomeUrl(
            SearchService.getSearchQueryParamsfromDestinationUpdate(
              Object.assign({}, this.$route.query),
              select,
              5
            )
          );
          break;
        case "place":
          bbox = SearchService.getBboxFromCoordsAndRadius(
            select.coordinates[0],
            select.coordinates[1],
            10
          );
          select.bbox = [bbox.xMin, bbox.yMin, bbox.xMax, bbox.yMax];
          this.updateHomeUrl(
            SearchService.getSearchQueryParamsfromDestinationUpdate(
              Object.assign({}, this.$route.query),
              select,
              10
            )
          );
          break;
        default:
          this.updateHomeUrl(
            SearchService.getSearchQueryParamsfromDestinationUpdate(
              Object.assign({}, this.$route.query),
              select,
              NaN
            )
          );
          break;
      }
    },
    /* Trigger by ThemeSelector */
    updateThemeFromAutocomplete(themes) {
      this.updateHomeUrl(
        SearchService.getSearchQueryParamsfromThemeUpdate(
          Object.assign({}, this.$route.query),
          themes
        )
      );
    },
    /* Trigger by TheMap  */
    updateBboxFromMap() {
      this.updateHomeUrl(
        SearchService.getSearchQueryParamsfromBboxUpdate(
          Object.assign({}, this.$route.query),
          this.bbox
        )
      );
    },
    updatePageFromPagination(number) {
      this.updateHomeUrl(
        SearchService.getSearchQueryParamsfromPageUpdate(
          Object.assign({}, this.$route.query),
          number
        )
      );
    },
    closeDestinationPage() {
      // eslint-disable-next-line no-unused-vars
      const { destinationId, ...newUrl } = this.$route.query;
      this.updateHomeUrl(newUrl);
    },
    /* Trigger by MediaSelector */
    updateSearchedMedia(media) {
      this.updateHomeUrl(
        SearchService.getSearchQueryParamsfromThemeSelectorUpdate(
          { ...this.$route.query },
          media
        )
      );
    },
    updateParameter(object) {
      this.updateHomeUrl(
        SearchService.getSearchQueryParamsfromParameterUpdate(
          { ...this.$route.query, page: 1 },
          object.value,
          object.parameter
        )
      );
    },
    /* UpdateUrl */
    updateHomeUrl(urlParams) {
      this.$router.push({
        name: this.$router.currentRoute.name,
        query: urlParams,
      });
    },
    updateSearchRadius(radius) {
      const coords = SearchService.getCoordsFromBbox(this.searchParams.bbox);
      this.updateHomeUrl(
        SearchService.getSearchQueryParamsfromUpdateRadius(
          { ...this.$route.query },
          SearchService.getBboxFromCoordsAndRadius(
            coords[0],
            coords[1],
            radius
          ),
          coords[0],
          coords[1],
          radius
        )
      );
    },
    /* update searchParams stored object from url query */
    updateSearchParams() {
      this.$store.dispatch("search/setSearchParams", {
        query: Object.assign({}, this.$route.query),
        username: this.username,
      });
    },
    updateState() {
      this.$store.dispatch(
        "search/setSearchState",
        SearchStateService.getSearchStateFromUrl(this.$route.query)
      );
    },
    /* trigger API call to retrieve posts via data object search */
    newSearch() {
      if (this.searchType === "destinations") {
        this.$store.dispatch("search/setSearchDestinations");
      } else if (this.searchType === "posts") {
        this.$store.dispatch("search/setSearchPosts");
      }
      this.isMapHadMoved = false;
    },
    /* Events */
    stopLoadingMap(status) {
      this.loading[status] = false;
    },
    bboxHasBeenUpdated(bbox) {
      /* Update isMapHadMoved if trigger by user action (map moving)*/
      this.bbox = bbox;
      if (!this.isTheMapMovingBounds) {
        this.isMapHadMoved = true;
        this.searchIfMapMove ? this.updateBboxFromMap() : 0;
      }
    },
    highlightLocation(locationApiId) {
      if (this.screenSizeAllowMapToBeDisplay) {
        for (
          let index = 0;
          index < this.searchPosts.locations.length;
          index++
        ) {
          if (
            this.searchPosts.locations[index].properties.apiId === locationApiId
          ) {
            this.$refs.theMap.highlightLocation(
              this.searchPosts.locations[index]
            );
            break;
          }
        }
      }
    },
    unHighlightLocation(locationApiId) {
      if (this.screenSizeAllowMapToBeDisplay) {
        for (
          let index = 0;
          index < this.searchPosts.locations.length;
          index++
        ) {
          if (
            this.searchPosts.locations[index].properties.apiId === locationApiId
          ) {
            this.$refs.theMap.unHighlightLocation(
              this.searchPosts.locations[index]
            );
            break;
          }
        }
      }
    },
    mapMovementState(state) {
      state === "moving" ? (this.isTheMapMovingBounds = true) : 0;
      state === "stop" ? (this.isTheMapMovingBounds = false) : 0;
    },
    /* Trigger by TheSearchNewSearchOnScrollingButton */
    switchSearchIfMapMove() {
      this.searchIfMapMove = !this.searchIfMapMove;
    },
    /* trigger by TheSearchNewSearchOnScrollingButton when click on "search in this area"  */
    searchInThisArea() {
      this.updateBboxFromMap();
    },
    openSearchFiltersMobile() {
      this.$refs.searchFiltersMobile.openBottomSheet();
    },
  },
  // LIFECYCLE HOOKS
  created() {
    // Will fetch themeByCategory if store doesn't have it yet
    if (
      !this.isThemesByCategoryHaveBeenFetched &&
      !this.themesByCategoryLoading &&
      !this.isFetchingThemesByCategory
    ) {
      this.$store.dispatch("core/updateThemesByCategory");
    }
    this.isTheSearchReady = true;
    // Quick fix to not show destinationId in query url when page is created
    if (
      this.$route.query.destinationId &&
      Number.isInteger(parseInt(this.$route.query.destinationId))
    ) {
      let newQuery = Object.assign({}, this.$route.query);
      delete newQuery["destinationId"];
      this.$router.push({
        name: this.$router.currentRoute.name,
        query: newQuery,
      });
    }
  },
  destroyed() {
    this.$store.dispatch("search/resetSearch");
  },
};
</script>

<style scoped>
.scoped--TheSearchNewSearchOnScrollingButton {
  top: 0;
  max-width: 70%;
  display: block;
  margin: auto;
}
.circleLoader {
  background-color: #f2f2f2;
  opacity: 0.8;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.opacityCircleLoader {
  opacity: 1;
}
.search-components {
  z-index: 1;
}
.search-posts {
  z-index: 0;
}
</style>
